import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const routerOptions = [
  { path: '/',
    component: 'Home',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Gestionale erboristeria')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Stores',
    component: 'ElencoNegozi',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Lista negozi')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ordini_clienti',
    component: 'ordini_clienti',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Ordini Clienti')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/spedizioni_gls',
    component: 'spedizioni_gls',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Spedizioni Gls')
        next()
      } else {
        next('/login')
      }
    }
  },
  { path: '/spedizioni_brt',
    component: 'spedizioni_brt',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Spedizioni BRT')
        next()
      } else {
        next('/login')
      }
    }
  },
  { path: '/TrasfGiacMag/New',
    component: 'TrasfGiacMag',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Richiedi trasferimento giacenza')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/TrasfGiacMag/:magazzino_cid/:numRic',
    component: 'TrasfGiacMag',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Richiedi trasferimento giacenza')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/TrasfGiacMag',
    component: 'TrasfGiacMag_Elenco',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Richieste provvisorie')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/StoresDetail/:id',
    component: 'DettaglioMagazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Dettaglio magazzino')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/StoresRequest/:id',
    component: 'Richieste_Magazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Richieste magazzino')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/StoresRequest/:id/:docnumero',
    component: 'Richieste_Dettaglio_Magazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Dettaglio richiesta magazzino')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/StoresArrived/:id',
    component: 'Arrivi_Magazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Arrivi magazzino')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Stores/:id/:sessione',
    component: 'Negozio',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Vendita Negozio')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Prime/:id/:sessione',
    component: 'Prime',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Spedizione Prime')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/PrimeHistory/:id',
    component: 'ElencoOrdiniPrime',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Archivio ordini Prime')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/StoresHistory/:id',
    component: 'ElencoOrdiniNegozio',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Archivio ordini negozio')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/fornitori',
    component: 'ElencoFornitori',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Fornitori')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/fornitori/:id',
    component: 'SchedaFornitore',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Scheda fornitore')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/OrdiniFornitori',
    component: 'OrdiniFornitori',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Ordini fornitori')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ProdottiDaOrdinare',
    component: 'prodotti_da_ordinare',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Prodotti da ordinare')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/OrdiniFornitori/:id',
    component: 'schedaOrdineFornitore',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Scheda ordine fornitore')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/CaricaBolla',
    component: 'CaricaBolla',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Carica Bolla')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/CaricaBolla/:numerobolla',
    component: 'CaricaBolla',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Carica Bolla')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/marche',
    component: 'Marche',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Marche')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/linee',
    component: 'Linee',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Linee')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/categorie/:id',
    component: 'Categorie',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Categorie')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ModProd/',
    component: 'ModProd',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Modifiche massive prodotti')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ProdNoGest/',
    component: 'ProdNoGest',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Prodotti degli ordini non presenti sul gestionale')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/tools/controlla_prodotti_pubblici_archiviati',
    component: 'controlla_prodotti_pubblici_archiviati',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Controllo prodotti pubblici')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/tools/prodotti_da_saldare',
    component: 'Ctrl_DaScalare',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Prodotti Da Saldare ')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/settings',
    component: 'settings',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Impostazioni ')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ConfBlank/',
    component: 'ConfBlank',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Controllo Confezioni')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/ordiniforn',
    component: 'stat_ordini_forn',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Statistiche Ordini Fornitori')
        next()
      } else {
        next('/login')
      }
    }},

  { path: '/statistiche/stat_movimentazioni',
    component: 'stat_movimentazioni',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'stat. movimentazioni')
        next()
      } else {
        next('/login')
      }
    }},

  { path: '/statistiche/previsioni',
    component: 'stat_previsioni',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Previsioni Ordini Fornitori')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/spedizioni',
    component: 'StatSped',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Statistiche Spedizioni')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/scadenze',
    component: 'ProdottiInScadenza',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Scadenze')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/reports',
    component: 'ElencoReports',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Reports')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/registro_log',
    component: 'registro_log',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Registro log')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/ricalcolaprod',
    component: 'RicalcolaProd',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Ricalcola Costi')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/prodottinonvenduti',
    component: 'StatProdNoVenduti',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Statistiche Vendite ')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/prodotti_stack',
    component: 'StatProdOverStock',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Statistiche OverStock ')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/statistiche/marginalita',
    component: 'StatisticheMarginalita',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Statistiche Marginalità ')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Prodotti/',
    component: 'ElencoProdotti',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Elenco prodotti')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Prodotto/:id',
    component: 'SchedaProdotto',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Scheda prodotto')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Movimenti',
    component: 'Movimenti',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Movimenti')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/InventarioHistory',
    component: 'ElencoInventari',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Elenco Inventari')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/InventarioGest',
    component: 'Inventario_Dashboard',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Inventario')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/InventarioDettaglio/:magazzino_cid/:inventario_cid/',
    component: 'Inventario_Dettaglio',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Inventario')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Inventario/:magazzino_cid/:inventario_cid/:sessione_cid/',
    component: 'Inventario',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Inventario')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/InventarioTools/:magazzino_cid/:inventario_cid/',
    component: 'Inventario_Tools',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Tools Inventario')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/Profilo/',
    component: 'Profilo',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Profilo')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '/login',
    component: 'login',
    beforeEnter (to, from, next) {
      store.commit('setPagina', 'Gestionale erboristeria')
      if (store.getters.isAuthenticated) {
        next('/')
      } else {
        next()
      }
    }},
  { path: '/recoveryPassword',
    component: 'recoveryPassword',
    beforeEnter (to, from, next) {
      store.commit('setPagina', 'Gestionale erboristeria')
      next()
    }},
  { path: '/carico_magazzino/:pk/',
    component: 'dettaglio_carico_magazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Carico magazzino - Mobile Version')
        next()
      } else {
        next('/login')
      }
    }
  },
  { path: '/carico_magazzino',
    component: 'carico_magazzino',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Carico magazzino - Mobile Version')
        next()
      } else {
        next('/login')
      }
    }
  },

  { path: '/NotPermission',
    component: 'NotPermission',
    name: '403',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Permesso Negato')
        next()
      } else {
        next('/login')
      }
    }},
  { path: '*',
    component: 'NotFound',
    name: '404',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        store.commit('setPagina', 'Pagina non trovata')
        next()
      } else {
        next('/login')
      }
    }}
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)
export default new Router({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js